import React, { useState, useEffect, useContext } from "react";
import { Box, Button, FormControl, InputLabel, Select, MenuItem,Link } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Portals } from "common/Portals";

export default function LandingPage() {
    const { setCurrentPortal, portals } = useContext(PrivateRoutesContext);

    const [isPortalButtonDisabled, setIsPortalButtonDisabled] = useState(false);

    useEffect(() => {
        localStorage.setItem('currentPortal', '');
        localStorage.setItem('deferredAcks', "");
    },[]);

    useEffect(() => {
        apiGet(apiUrls.getRoles).then((response) => {
            let userRoles = response.data.map(d => d.applicationRoleCode);
            let matchingPortals = Portals.filter(r => r.Roles.filter(value => userRoles.includes(value)).length > 0);
            if (matchingPortals.length === 1) {
                navigateToPortal(matchingPortals[0].Portal)
            }
        });
    },[portals]);

    const navigateToPortal = (portal) => {
        setIsPortalButtonDisabled(true);
        setCurrentPortal(portal);
    }

    return (
        <Box className="container-fluid"
             style={{
                 maxWidth: "800px",
                 height:"100vh",
                 width:"100%",
                 display:"flex",
                 alignItems:"center",
                 justifyContent:"center"
             }}>
            {portals === null ?
                <Box>Loading available portals...</Box>
            : portals.length === 0 ?
                <Box>No portals available for the logged in user. <Link href="/logout" >Logout</Link></Box>
            : portals.length === 1 ?
                <Box>Redirecting...</Box>
            :
                <Box>
                    <Box className="text-center mb-3">
                        <h3>Select portal to visit</h3>
                    </Box>
                    <Box sx={{flexBasis:"100%", height:"0"}}></Box>
                    {portals.map((p,i) => (
                        <Button
                            key={i}
                            onClick={() => navigateToPortal(p.Portal)}
                            variant="outlined"
                            className="mx-2"
                            disabled={isPortalButtonDisabled}
                        >
                            {p.Label}
                        </Button>
                    ))}
                </Box>
            }
        </Box>
    );
}